import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const EInvoiceIntegration = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        E-Fatura Entegrasyonu
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Dijital Planet e-fatura entegrasyonu burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default EInvoiceIntegration;
